<template>
  <div>
    <booking-menu-with-budget-header :title="$t('booking.rail.title')" />
    <v-row />

    <v-card-title>
      <v-row>
        <v-col md="3" sm="5" cols="12">
          <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details />
        </v-col>
      </v-row>
    </v-card-title>
    <booking-rail-data-table :search="search"> </booking-rail-data-table>
  </div>
</template>

<script>
import BookingRailDataTable from "../../components/Booking/BookingRailDataTable.vue";
import BookingMenuWithBudgetHeader from "../../components/Booking/BookingMenuWithBudgetHeader";

export default {
  name: "BookingRailView",
  components: {
    BookingMenuWithBudgetHeader,
    BookingRailDataTable
  },
  data: () => ({
    search: ""
  }),
  computed: {},
  methods: {},
  created() {}
};
</script>

<style scoped></style>
